module.exports = __webpack_public_path__ + "img/toolExo.17f14e5d.png";